import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import placeholderCard from 'styles/assets/placeholder/placeholderCard.gif';
import { formatUrl, isFrameUrl, trackEventMatomoElementId } from 'js/library/utils/helpers';
import { downloadImage } from 'js/library/services/StorageManager.js';

export default function Cards({ cardInfo, uId }) {
  const card = cardInfo;
  let url = formatUrl(card, uId);
  const navigate = useNavigate();
  const [cardImage, setCardImage] = React.useState(placeholderCard);

  const fileNameExist = card.images.web.includes('cards/');

  const downloadImageOnLoad = () => {
    if (cardImage === placeholderCard && card.images.web) {
      downloadImage('cards', card.images.web, fileNameExist)
        .then((downloaded) => {
          setCardImage(downloaded);
        })
        .catch((error) => {
          return error;
        });
    }
  };

  const handleOpenUrl = (event) => {
    if (card.appFilter?.itemId === 'directNavigation' || isFrameUrl(url)) {
      event.preventDefault();
      const urlRedirect = new URL(url, window.location.origin);
      navigate(urlRedirect.pathname + urlRedirect.search);
    }
  };

  if (card.action === 'browser' || card.action === 'webview') {
    return (
      <a href={url} target="new" onClick={handleOpenUrl}>
        <img
          className={'home-paper-card'}
          alt="card"
          onLoad={() => downloadImageOnLoad()}
          src={cardImage}
        />
      </a>
    );
  } else {
    url = url.split('?');

    return (
      <Link
        onClick={() => {
          trackEventMatomoElementId('Organizacao', 'tocar', 'card', `${card.cardId || 'card'}`);
        }}
        onLoad={() => downloadImageOnLoad()}
        to={{ pathname: url[0], search: url[1] }}
        state={card}
        style={{ textDecoration: 'none' }}
      >
        <img className="home-paper-card" alt="card" src={cardImage} />
      </Link>
    );
  }
}
